import { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { emailRegex } from "../../utils/helper.js";
import Header from "../Navigation/Header";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import UserContext from "../../contexts/UserContext";

function Suggestion() {
	const [error, setError] = useState("");
	const [info, setInfo] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const submitText = t("page.submit");

	const initialValues = {
		email: userCtx.loggedInUserId || '',
		name: "",
		phone: "",
		description: "",
	};
	const [formValues, setFormValues] = useState(initialValues);

	useEffect(() => {
		if(!userCtx.isAuthenticated){
			navigate("/");
		}
	}, []);

	const valueHandler = (e) => {
		const { name, value } = e.target;
		setFormValues({ ...formValues, [name]: value });
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		setInfo("");
		setIsSubmit(true);
		const formData = new FormData(event.currentTarget);
		for (let entry of formData.entries()) {
			formValues[entry[0]] = entry[1];
		}
		let errors = validateFields();
		setFormErrors(errors);
		if (!errors || errors.length === 0) {
			addSuggestion();
		} else {
			setIsSubmit(false);
		}

	};
	const validateFields = () => {
		const errors = [];
		let email = (formValues.email) ? formValues.email.trim() : '';
		let phone = (formValues.phone) ? formValues.phone.trim() : '';
		let description = (formValues.description) ? formValues.description.trim() : '';
		if (!email && !phone) {
			errors.push(t("error.phoneEmailReqd"));
		} else if (email) {
			if (!emailRegex.test(email)) {
				errors.push(t("error.invalidEmail"));
			}
		}

		if (!description) {
			errors.push(t("error.descReqd"));
		}

		return errors;
	};
	const addSuggestion = () => {
		let serverParams = {
			email: (formValues.email) ? formValues.email.trim() : '',
			name: (formValues.name) ? formValues.name.trim() : '',
			phone: (formValues.phone) ? formValues.phone.trim() : '',
			description: (formValues.description) ? formValues.description.trim() : '',
			source: "web",
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddSuggestion", "/Service/UserService/AddSuggestion", requestOptions, addSuggestionSuccess, addSuggestionFail);
		} catch (error) {
			setError(error.message);
			setIsSubmit(false);
		}
	};

	function addSuggestionFail(redirect) {
		setIsSubmit(false);
		setError(t("error.addSuggestFailed"));
	}
	function addSuggestionSuccess(responseData) {
		setIsSubmit(false);
		let suggestionResponse;
		if (responseData) {
			suggestionResponse = responseData.suggestionResponse;
			if (suggestionResponse) {
				if (suggestionResponse.errorCode === "0") {
					formValues.description="";
					setInfo(t("info.addSuggest"));
				} else {
					setError(t("error.error") + " " +
						suggestionResponse.errorMessage
					);
				}
			}
		}
	}

	return (
		<>
			<Header />
			<div id="page">
				<div className="page-inner">
					<div id="main">
						<div className="row">
							<div className="col-md-3 col-sm-3 col-sx-12"></div>
							<div className="col-md-6 col-sm-6 col-sx-12">
								{((formErrors && formErrors.length > 0) || error) && (
									<div id="inerrorMessage" className="errorblock">
										{((formErrors && formErrors.length > 0) || error) ? (
											formErrors.map((errorData, index) => (
												<p className="message-line">{errorData}</p>
											))
										) : ""}
										{error}
									</div>
								)}
								{(info && (
									<div style={{ backgroundColor: "#1d7d16", color: "white" }}>
										<b>{info}</b>
									</div>
								)
								)}
							</div>
						</div>
						<div className="row">
							<div className="col">
								<form
									className="regn_form_container"
									acceptCharset="UTF-8"
									id="sign-up"
									onSubmit={handleSubmit}
								>
									<h2>{t("header.report.suggest")}
									</h2>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label htmlFor="email" className="form-label">
													<span className="form_required">*</span>
													{t("page.email")}
												</label>
												<input
													type="text"
													name="email"
													id="email"
													placeholder="Email"
													maxLength="50"
													value={formValues.email}
													onChange={(e) => valueHandler(e)}
													className="form-control rounded-pill border-0 shadow-sm px-4"
												/>
											</div>
										</div>

									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.name")}
												</label>
												<input name="name" value={formValues.name} maxlength="50"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.phone")}
												</label>
												<input name="phone" value={formValues.phone}
													maxlength="12" className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.suggest.desc")}
												</label>
												<textarea rows="5" cols="50" name="description" id="description"
													maxlength="10000" className="rounded-pill border-0 shadow-sm px-4 suggest-txt" wrap="hard"
													onChange={(e) => valueHandler(e)} >{formValues.description}</textarea>
											</div>
										</div>
									</div>
									<div className="footer">
										<div id="submit-spinner"
											className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
										>  </div>
										<input
											type="submit"
											name="edit-submit"
											id="edit-submit"
											data-dismiss="modal"
											className="btn btn-primary btn-block"
											style={{ marginBottom: "10px" }}
											value={submitText}
											disabled={isSubmit}
										>
										</input>

									</div>
								</form>
							</div>
						</div>
						<div className="row">
							<div className="col mt-3">
								{((formErrors && formErrors.length > 0) || error) && (
									<div id="berrorMessage" className="errorblock">
										{((formErrors && formErrors.length > 0) || error) ? (
											formErrors.map((errorData, index) => (
												<p className="message-line">{errorData}</p>
											))
										) : ""}
										{error}
									</div>
								)}
							</div>
						</div>
						{(info && (
							<div style={{ backgroundColor: "#1d7d16", color: "white" }}>
								<b>{info}</b>
							</div>
						)
						)}
						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg" style={{ height: "10px" }}></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Suggestion;